import { render } from "./OverlayElementIColor.vue?vue&type=template&id=32288bf8&scoped=true"
import script from "./OverlayElementIColor.vue?vue&type=script&lang=js"
export * from "./OverlayElementIColor.vue?vue&type=script&lang=js"

import "./OverlayElementIColor.vue?vue&type=style&index=0&id=32288bf8&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32288bf8"]])

export default __exports__